import { IsInt, IsNotEmpty, IsOptional, IsUUID, Min } from 'class-validator'
import { ApiProperty, ApiPropertyOptional } from '@nestjs/swagger'

export class CreateChapterTeachingDto {
  @ApiProperty({ description: 'ID du chapitre', type: 'string' })
  @IsNotEmpty()
  @IsUUID('4')
  chapterId!: string

  @ApiProperty({ description: "ID de l'enseignement", type: 'string' })
  @IsNotEmpty()
  @IsUUID('4')
  teachingId!: string

  @ApiProperty({ description: 'ID de la matière (dénormalisé pour contrainte FK)', type: 'string' })
  @IsNotEmpty()
  @IsUUID('4')
  subjectExternalId!: string

  @ApiProperty({ description: 'ID du niveau (dénormalisé pour contrainte FK)', type: 'string' })
  @IsNotEmpty()
  @IsUUID('4')
  levelExternalId!: string

  @ApiPropertyOptional({ description: 'Numéro d\'ordre', type: Number })
  @IsOptional()
  @IsInt()
  @Min(1)
  orderNumber?: number
}
